export const PostStatuses = {
    Draft: 1,
    Scheduled: 2,
    Published: 3
}